import { render, staticRenderFns } from "./ModalSuporteProcedimento.vue?vue&type=template&id=59820e13&scoped=true"
import script from "./ModalSuporteProcedimento.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteProcedimento.vue?vue&type=style&index=0&id=59820e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59820e13",
  null
  
)

export default component.exports